import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, Inject, Input, Output, EventEmitter, PLATFORM_ID, OnDestroy, ViewChildren,ViewChild, ElementRef, QueryList, HostListener, HostBinding, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
//import $ from 'jquery';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject, combineLatest } from 'rxjs';
import { error } from 'node:console';
import { Tooltip } from 'bootstrap'
import { TimePickerComponent } from '../../../../components/time-picker/time-picker.component';

@Component({
  selector: 'app-rep-resource-timesheet',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule, FormsModule, DatePickerModule, TimePickerComponent, RouterLink],
  providers: [Base64UrlService],
  templateUrl: './rep-resource-timesheet.component.html',
  styleUrl: './rep-resource-timesheet.component.scss'
})
export class RepResourceTimesheetComponent {
  @ViewChild('btntraining_history_popup') cngButton!: ElementRef;
  // 代理処理タブから埋め込み起動する場合の入力
  @Input() inputId?: string;
  @Input() inputUserId?: string;
  @Input() embeddedMode?: boolean;
  @HostBinding('class.embedded-mode') get isEmbeddedMode() { return !!this.embeddedMode; }
  @Output() backClicked = new EventEmitter<void>();
  @Output() logClicked = new EventEmitter<void>();
  
  userName: any;
  lang: any;
  userCode: any;
  timeSheetTopPannel: any;
  tsSummary: any = null;
  monthDropdown: any;
  timeSheetData: any;
  timeSheetCmnData: any;
  jobOrderData: any;
  noteTypes: any;
  expensesTypes: any;
  timesheetId: any;
  timesheetIdOrg: any;
  userId: any;
  userIdOrg: any;
  editingRow: number | null = null;
  dashboard_msg: any;
  msgType: any;
  selectAll = false;
  selectedTimesheetId: number | string = '';
  isButtonDisabled: boolean = false;
  expandedRows: boolean[] = [];
  expandedRowsButton: boolean[] = [];
  rowBackups: Record<number, any> = {};
  previousNoteIds: Record<number, any> = {};
  savedScrollPositions: Record<number, number> = {};
  thread_msg: any;
  trainingCommentsDis: string = '';
  trainingComments: string = '';
  hasUnsavedChanges = false;
  isSaving = false;
  archive: boolean = false;
  showSaveToast = false;
  private saveToastTimer: ReturnType<typeof setTimeout> | null = null;
  hourDropDown: string[] = [];
  endHourDropDown: string[] = [];
  minuteDropDown: string[] = []; 

  dashboard_err_msg: { row: number; message: string; disDate: string }[] = [];
  
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private pageTitle: PageTitleService, private ts: TimesheetService, private en: EncryptionService, private http: HttpClient, private router: Router,
   private safeUrl: Base64UrlService, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef
  ) { 
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
      console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    console.log('🚀 rep-resource-timesheet component initialized');
    console.time('⏱️ Total ngOnInit');
    
    this.userCode = this.auth.getCode();
    if (isPlatformBrowser(this.platformId)) {
      const rawId = this.inputId ?? this.route.snapshot.params['id'];
      const rawUserId = this.inputUserId ?? this.route.snapshot.params['userId'];
      // this.timesheetId = Base64UrlService.decode(this.en.decryptionAES(decodeURIComponent(rawId)));
      this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(rawId));
      //  console.log(this.timesheetId);
     // this.timesheetId = decodeURIComponent(rawId);
      this.timesheetIdOrg = rawId;
      this.userId = this.en.decryptionAES(Base64UrlService.decode(rawUserId));
      this.userIdOrg = rawUserId;
      
      this.dashboard_msg = null;
      this.dashboard_msg = localStorage.getItem('dashboard_msg');    
      localStorage.removeItem('dashboard_msg');
      this.thread_msg = null;
    
      this.userName = this.auth.getName();
      this.pageTitle.setTitle('menu.proxyapply');
      this.selectedTimesheetId = this.timesheetId;
      this.getMonthDropDown();
      // 初回ロード時は必ず最新データを取得する（ASC/Clientによる変更を反映するためキャッシュを破棄）
      this.ts.invalidateTimesheetDataCache(this.timesheetId);
      this.ts.clearTsInfoSummaryCache(this.timesheetId);
      this.getTimesheetData();
    }
    
    console.timeEnd('⏱️ Total ngOnInit');
  }

  @ViewChildren('tooltipEl', { read: ElementRef }) tooltipElements!: QueryList<ElementRef>;
  @ViewChildren(TimePickerComponent) allTimePickers!: QueryList<TimePickerComponent>;

  /** 指定行のタイムピッカー表示を直接強制更新（ngOnChanges/CD に依存しない） */
  private forceTimePickers(index: number, item: any): void {
    const pickers = this.allTimePickers?.toArray();
    if (!pickers) return;
    const startPicker = pickers[index * 2];
    const endPicker   = pickers[index * 2 + 1];
    if (startPicker) startPicker.forceDisplay(item.startHour, item.startMinute);
    if (endPicker)   endPicker.forceDisplay(item.endHour, item.endMinute);
  }

  triggerClick() {
    this.cngButton.nativeElement.click();
  }

  ngAfterViewInit() {
    this.initTooltips();
    this.tooltipElements.changes.subscribe(() => this.initTooltips());
  }

  private initTooltips(): void {
    this.tooltipElements.forEach((el) => new Tooltip(el.nativeElement));
  }
  
  getShortText(text: string, limit: number = 30): string {
    return text && text.length > limit ? text.substring(0, limit) + '...' : text;
  }
    
  getMonthDropDown() {
    // this.ts.getMonthList()
    // this.ts.getMonthWithTimesheetId()
    this.ts.getMonthWithTimesheetIdNew(this.userId)
    .subscribe({
      next: (resMonthList: any) => {
        if (resMonthList.status) {
          this.monthDropdown = resMonthList.data;          
        } else {
          this.dashboard_msg = "dataRetriveErrorMessage";
          this.msgType = "danger";           
          this.isButtonDisabled = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // console.log(this.monthDropdown);        
      },
      error: (err: any) => {        
        if (err.status == 401) {
          this.auth.logout();
		  return
        } else {
          this.dashboard_msg = "dataRetriveErrorMessage";
          this.msgType = "danger";           
          this.isButtonDisabled = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  }

  selectStartTime(i: number) {
    setTimeout(() => {
      const el: any = document.querySelector(
        `#startTime_${i} input`
      );
      if (el) {
        el.select();
        el.focus();
      }
    });
  }

  selectFinishTime(i: number) {
    setTimeout(() => {
      const el: any = document.querySelector(
        `#endTime_${i} input`
      );
      if (el) {
        el.select();
        el.focus();
      }
    });
  }
  
  savePrevNote(index: number): void {
    this.previousNoteIds[index] = this.timeSheetData[index]?.noteId;
  }

  chkNote(event: any, index: number) {
    const target = event.target as HTMLSelectElement;
    const noteId = target.value;   
    const item = this.timeSheetData[index];    
    if (noteId == '20' || noteId == '50') {
      // バックアップがなければ保存（cancelRowExpandedで復元できるように）
      if (!this.rowBackups[index]) {
        this.rowBackups[index] = JSON.parse(JSON.stringify(this.timeSheetData[index]));
        // [(ngModel)]はchangeより先にnoteIdを更新するため、(focus)で保存しておいた変更前の値に戻す
        if (this.previousNoteIds[index] !== undefined) {
          this.rowBackups[index].noteId = this.previousNoteIds[index];
        }
      }
      item.startHour = '';
      item.startMinute = '';
      item.endHour = '';
      item.endMinute = '';
      item.midnightBreakMinutes = '';
      item.breakMinutes = '';
      item.expenseId = '0';
      item.cost = '';
      item.whf = false;
    }
    this.markDirty();
  }

  chkSubmitCnt() {
    const eligible = this.timeSheetData.filter((item: any) => item.status < 20);
    const total = eligible.length;
    const checked = eligible.filter((item: any) => item.markedForSubmit).length;
    this.selectAll = (total > 0 && checked === total);
    this.markDirty();
  }
  
  getTimeDiffInMinutes(start: string, end: string) {    
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    const diffMs = endTime - startTime;
    const diffMin = Math.floor(diffMs / (1000 * 60));    // convert to minutes
    let rt = this.addMinutesWithOverflow(start, diffMin).split('T')[1].split(':');
    let finalEndTime = `${parseInt(rt[0], 10)}:${rt[1]}`;
    return finalEndTime;
  }
  
  addMinutesWithOverflow(dateStr: string, minutes: number): string {
    const base = new Date(dateStr);
  
    // Add minutes normally
    const updated = new Date(base.getTime() + minutes * 60000);
  
    // Calculate total minutes since start of the day
    const diffMs = updated.getTime() - new Date(base.toDateString()).getTime();
    const totalMinutes = diffMs / 60000;
  
    const hours = Math.floor(totalMinutes / 60);
    const mins = Math.floor(totalMinutes % 60);
  
    // Format back as overflow time
    const hh = hours.toString().padStart(2, '0');
    const mm = mins.toString().padStart(2, '0');
  
    const datePart = dateStr.split("T")[0];
  
    return `${datePart}T${hh}:${mm}:00`;
  }

  hasZeroTime(dt: string): boolean {
    return dt.split("T")[1] === "00:00:00";
  }
  getTimesheetData() {
    console.time('⏱️ Total getTimesheetData');

    this.dashboard_msg = null;
    this.dashboard_err_msg = [];

    const getTimeSheetByIdCached = this.ts.getTimeSheetByIdCached(this.timesheetId);
    const getTsInfoSummary       = this.ts.getTsInfoSummary(this.timesheetId);
    const getNoteTypes           = this.ts.getNoteTypes();
    const getExpensesTypes       = this.ts.getExpensesTypes();

    combineLatest([getTimeSheetByIdCached, getTsInfoSummary, getNoteTypes, getExpensesTypes])
      .subscribe({
        next: ([res, summary, resNote, resExpenses]: [any, any, any, any]) => {
          if (res.status) {
            console.log('📊 Raw data count:', res.data.lineItems?.length || 0);
            console.time('⏱️ Map and Calculate');

            this.archive = res.data.isArchived;
            this.timeSheetCmnData = res.data.timeSheet;
            this.trainingComments = this.timeSheetCmnData.trainingComments;
            this.trainingCommentsDis = this.timeSheetCmnData.trainingComments;
            this.timeSheetData = res.data.lineItems.map((item: any) => {
            // Pre-calculate all template functions
            const dayWeekData = this.getDayWeekKey(item.dayDate);
            const statusData = this.getStatus(item.status);
            const noteData = this.getNote(item.noteId);
            const expensesData = this.getExpenses(item.expenseId);
            const statusClass = this.getClass(item.status);

            return {
              ...item,
              // 楽観的同時実行制御用
              originalUpdateDate: item.updateDate,
              // Convert start/finish/breaks into HH:mm for direct binding
              startTime: (item.startTime == '1972-01-12T00:00:00') ? '' : this.toTimeString(item.startTime),
              startHour: ((item.isHoliday && item.startTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : parseInt(this.toTimeString(item.startTime).split(":")[0]),
              startMinute: ((item.isHoliday && item.startTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? ''  : String(this.toTimeString(item.startTime).split(":")[1].padStart(2, '0')),
              startTimeOrg: item.startTime,

              difTime: this.getTimeDiffInMinutes(item.startTime, item.endTime),
              endHour: ((item.isHoliday && item.endTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : parseInt(this.getTimeDiffInMinutes(item.startTime, item.endTime).split(":")[0]),
              endMinute: ((item.isHoliday && item.endTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : String(parseInt(this.getTimeDiffInMinutes(item.startTime, item.endTime).split(":")[1])).padStart(2, '0'),
              endTime: (item.endTime == '1972-01-12T00:00:00') ? '' : String(this.getTimeDiffInMinutes(item.startTime, item.endTime)).padStart(2, '0'),
              endTimeOrg: item.endTime,
              breakMinutes: ((item.isHoliday && item.breakMinutes == 0) || (item.breakMinutes == 0)) ? '' : item.breakMinutes,
              midnightBreakMinutes: ((item.isHoliday && item.midnightBreakMinutes	 == 0) || (item.midnightBreakMinutes	 == 0)) ? '' : item.midnightBreakMinutes,
              markedForSubmit: false,
              // Pre-calculated template values
              dayWeekDay: dayWeekData.day,
              dayWeekKey: dayWeekData.weekdayKey,
              dayWeekShort: dayWeekData.shortweekday,
              statusKey: statusData.statusKey,
              statusClass: statusClass,
              noteKey: noteData.noteKey,
              expensesKey: expensesData.expensesKey,
              isApproved: item.status === 30 || item.status === 40,
              isEditing: false
            };
            });

            console.timeEnd('⏱️ Map and Calculate');
            console.log('📊 Processed data count:', this.timeSheetData?.length || 0);
            console.log('✅ Data ready, Angular will now render...');
            // 展開中の行のrowBackupsを最新データで更新（元に戻すバグ防止）
            this.expandedRows.forEach((isOpen, i) => {
              if (isOpen && this.timeSheetData[i]) {
                this.rowBackups[i] = JSON.parse(JSON.stringify(this.timeSheetData[i]));
              }
            });
            this.timeSheetTopPannel = res.data.timesheetSummary[0];
            this.tsSummary = summary;
            this.jobOrderData = res.data.jobOrder;
            this.hourDropDown = Array.from({ length: 24 }, (_, i) => String(i));
            this.endHourDropDown = Array.from({ length: 48 }, (_, i) => String(i));
            this.minuteDropDown = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

            this.hourDropDown.unshift('');
            this.endHourDropDown.unshift('');
            this.minuteDropDown.unshift('');

            if (resNote.status) {
              this.noteTypes = resNote.data;
            } else {
              this.dashboard_msg = "dataRetriveErrorMessage";
              this.msgType = "danger";
              this.isButtonDisabled = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }

            // 業務交通費(typeID=2)を上、その他立替金(typeID=1)を下に表示
            if (resExpenses.status) {
              this.expensesTypes = [...resExpenses.data].sort((a: any, b: any) => b.typeID - a.typeID);
            } else {
              this.dashboard_msg = "dataRetriveErrorMessage";
              this.msgType = "danger";
              this.isButtonDisabled = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }

            console.timeEnd('⏱️ Total getTimesheetData');
            console.log('🎉 All data loaded!');
          }
        },
        error: (err: any) => {
          console.timeEnd('⏱️ Total getTimesheetData');
          if (err.status == 401) {
            this.auth.logout();
            return;
          } else {
            this.dashboard_msg = "dataRetriveErrorMessage";
            this.msgType = "danger";
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      });
  }

  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short' });
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric' });
  }

  getOptionTitle(date: any): string {
    const year = this.getYear(date.weekEnding);
    const month = this.translate.instant('DDMONTH.' + this.getMonth(date.weekEnding));
    const term = date.contractTerm ? ` ${date.contractTerm}` : '';
    return `${year} ${month} (${date.companyName}${term})`;
  }

ngOnDestroy(): void {
    // コンポーネント破棄時（proxyOperation 変更による *ngIf アンマウント）にタイトルをクリア
    this.pageTitle.setTitle('');
    if (isPlatformBrowser(this.platformId)) {
      const table = ($('#attendanceTable') as any).DataTable();
      if (table) {
        table.destroy(true);
      }
    }
  }

  get allApproved(): boolean {
    return this.timeSheetData?.length > 0 && this.timeSheetData.every((item: any) => item.status === 40);
  }

  onSave(): void {
    this.isButtonDisabled = true;
    this.isSaving = true;
    this.dashboard_msg = null;
    this.dashboard_err_msg = []; // reset previous errors

    const hasError = this.validateAllRows();
    // stop if any error found
    if (hasError) {
      const errMsg = this.translate.instant('VALIDATION_FAILED');
      alert(errMsg);
      this.isSaving = false;
      return;
    } 
    // console.log(this.timeSheetData[0])
    // Prepare payload
    const details = this.timeSheetData.map((item: any) => ({
      timesheetLineItemId: item.timesheetLineItemId ?? 0,
      dayDate: item.dayDate ?? '',
      // startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg),
      // endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg)).toISOString() ?? '',
      startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg, item.dayDate),  //2026-07-21 add
      endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg, item.dayDate)).toISOString() ?? '', //2026-07-21 add     
      midnightBreakMinutes:  parseInt(item.midnightBreakMinutes, 10) ?? 0,
      breakMinutes:  parseInt(item.breakMinutes, 10) ?? 0,
      noteId: item.noteId ?? 0,
      expenseId: item.expenseId ?? 0,      
      status: item.markedForSubmit ? 20 : item.status,
      workingType: item.markedForSubmit ? 10 : (item.workingType ?? 0),
      cost: parseInt(item.cost, 10) ?? 0,
      whf: item.whf ?? false,
      etcRemarks: item.etcRemarks ?? '',
      originalUpdateDate: item.originalUpdateDate
    }));
    const comments = this.timeSheetCmnData.comments;
    // console.log(comments),
    const payload = {
      timesheetId: this.timesheetId, // Set this as needed
      details,
      comments: comments
    };
    
    // console.log(payload);
    // return;
    this.ts.saveTimeSheet(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // console.log(res.message)
            this.hasUnsavedChanges = false;
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            this.isButtonDisabled = false;
            this.triggerSaveToast();
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "danger";
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
          this.isSaving = false;
        },
        error: (err: any) => {
          this.isSaving = false;
          console.log(err.message);
          if (err.status == 401) { 
            this.auth.logout();
			      return;
          } else if (err.status == 409) {
            // 競合エラー: 他のユーザーによる更新
            this.dashboard_msg = err.error?.message || "このタイムシートは他のユーザーによって更新されています。画面を再読み込みしてください。";
            this.msgType = "warning";
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = err.error?.message || "dataSaveErrorMessage";
            this.msgType = "danger";
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
    })
  }

  triggerSaveToast(): void {
    if (this.saveToastTimer !== null) {
      clearTimeout(this.saveToastTimer);
    }
    this.showSaveToast = true;
    this.saveToastTimer = setTimeout(() => {
      this.showSaveToast = false;
      this.saveToastTimer = null;
    }, 1000);
  }

  convertOverflowDate(dateStr: string): Date {
    // Remove trailing Z and split
    const [datePart, timePart] = dateStr.replace('Z', '').split('T');
  
    const baseDate = new Date(datePart);
    // Convert time part (25:00:00.000) into total milliseconds
    const [h, m, s] = timePart.split(':');
    const [sec, ms = "0"] = s.split('.');
  
    const totalMs =
      Number(h) * 3600000 +
      Number(m) * 60000 +
      Number(sec) * 1000 +
      Number(ms);
  
    // Add overflow time to date
    return new Date(baseDate.getTime() + totalMs);
  }

  scrollToRow(row: number) {
    const el = $('.timeSheet_row').eq(row - 1)[0];
    if (!el) return;

    // ビューポート内かチェック
    const rect = el.getBoundingClientRect();
    const inViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (!inViewport) {
      const top = rect.top + window.scrollY - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // ハイライト（スクロール有無に関わらず）
    el.classList.remove('row-highlight');
    void el.offsetWidth; // reflow でアニメーションリセット
    el.classList.add('row-highlight');
    setTimeout(() => el.classList.remove('row-highlight'), 2000);
  }
  
  private addError(rowIndex: number, message: string, disDate: string = '') {
    const exists = this.dashboard_err_msg.some(
      e => e.row === rowIndex && e.message === message
    );

    if (!exists) {
      this.dashboard_err_msg.push({ row: rowIndex, message, disDate });
    }
  }

  validateAllRows(): boolean {
    this.dashboard_err_msg = [];
    let overallHasError = false;
    this.timeSheetData.forEach((_: any, index: number) => {
      if (this.validateRow(index)) {
        overallHasError = true;
      }
    });
    return overallHasError;
  }
  
 
  validateRow(index: number): boolean {
    const item = this.timeSheetData[index];

    // Reset invalid flags
    item.startInvalid = false;
    item.endInvalid = false;
    item.breakInvalid = false;
    item.mnBreakInvalid = false;
    item.costInvalid = false;
    item.whfInvalid = false;

    // Get values as strings
    const startHour = item.startHour?.toString() || '';
    const startMinute = item.startMinute?.toString() || '';
    const endHour = item.endHour?.toString() || '';
    const endMinute = item.endMinute?.toString() || '';
    const breakTime = item.breakMinutes?.toString() || '';
    const mnBreakTime = item.midnightBreakMinutes?.toString() || '';
    const noteVal = parseInt(item.noteId?.toString() || '0', 10);
    const expensesVal = parseInt(item.cost?.toString() || '0', 10);
    const expensesDropDwn = parseInt(item.expenseId?.toString() || '0', 10);

    const finalStart = (parseInt(startHour, 10) || 0) * 60 + (parseInt(startMinute, 10) || 0);
    const finalEnd = (parseInt(endHour, 10) || 0) * 60 + (parseInt(endMinute, 10) || 0);
    const workTime = finalEnd - finalStart;

    // 日中勤務時間（5:00〜22:00, 29:00〜46:00 に重なる部分）
    const dayBand1   = Math.max(0, Math.min(finalEnd, 22 * 60) - Math.max(finalStart,  5 * 60));
    const dayBand2   = Math.max(0, Math.min(finalEnd, 46 * 60) - Math.max(finalStart, 29 * 60));
    const dayWorkTime = dayBand1 + dayBand2;

    // 深夜勤務時間（0:00〜5:00, 22:00〜29:00, 46:00〜48:00 に重なる部分）
    const nightBand1    = Math.max(0, Math.min(finalEnd,  5 * 60) - Math.max(finalStart,       0));
    const nightBand2    = Math.max(0, Math.min(finalEnd, 29 * 60) - Math.max(finalStart, 22 * 60));
    const nightBand3    = Math.max(0, Math.min(finalEnd, 48 * 60) - Math.max(finalStart, 46 * 60));
    const nightWorkTime = nightBand1 + nightBand2 + nightBand3;

    let hasError = false;

    // Validate start/end completeness
    if (
      (startHour === '' || startMinute === '' || endHour === '' || endMinute === '') &&
      !(startHour === '' && startMinute === '' && endHour === '' && endMinute === '')
    ) {
      if (startHour === '' || startMinute === '') {
        item.startInvalid = true;
        this.addError(index + 1, 'err1', this.getDisDate(item));
        hasError = true;
      }
      if (endHour === '' || endMinute === '') {
        item.endInvalid = true;
        this.addError(index + 1, 'err2', this.getDisDate(item));
        hasError = true;
      }
    } else if (startHour === '' && startMinute === '' && endHour === '' && endMinute === '') {
      // All blank - OK
    } else {
      // All filled - check order
      if (finalStart >= finalEnd) {
        item.startInvalid = true;
        item.endInvalid = true;
        this.addError(index + 1, 'err3', this.getDisDate(item));
        hasError = true;
      } else {
        // -----------------------------
        // OVERLAP VALIDATION
        // -----------------------------
        if (finalStart >= 0 && finalEnd > 0) {
          const curr = this.timeSheetData[index];
          const currStart = this.getAbsoluteMinutes(
            curr.dayDate,
            curr.startHour,
            curr.startMinute
          );
          const currEnd = this.getAbsoluteMinutes(
            curr.dayDate,
            curr.endHour,
            curr.endMinute
          );

          // --------------------
          // PREVIOUS ROW CHECK
          // --------------------
          const prev = this.timeSheetData[index - 1];
          if (prev) {
            const prevEnd = this.getAbsoluteMinutes(
              prev.dayDate,
              prev.endHour,
              prev.endMinute
            );
            if (prevEnd >= 0 && currStart < prevEnd) {
              item.startInvalid = true;
              this.addError(
                index + 1,
                'StartOverlap',
                this.getDisDate(item)
              );
              hasError = true;
            }
          }

          // --------------------
          // NEXT ROW CHECK
          // --------------------
          const next = this.timeSheetData[index + 1];
          if (next) {
            const nextStart = this.getAbsoluteMinutes(
              next.dayDate,
              next.startHour,
              next.startMinute
            );
            if (nextStart >= 0 && currEnd > nextStart) {
              item.endInvalid = true;
              this.addError(
                index + 1,
                'EndOverlap',
                this.getDisDate(item)
              );
              hasError = true;
            }
          }
        }
      }
    }

    // BREAK TIME validation
    const breakRegex = /^(?:0|[1-9]\d{0,2}|1[0-3]\d{2}|14[0-3]\d|1440)$/;
    if (breakTime === '' || breakTime === undefined) {
      item.breakInvalid = false;
    } else if (breakRegex.test(breakTime)) {
      // 日中勤務時間（5:00〜22:00 + 29:00〜46:00）< 休憩時間 → エラー
      if (parseInt(breakTime, 10) > dayWorkTime) {
        item.breakInvalid = true;
        this.addError(index + 1, 'err4', this.getDisDate(item));
        hasError = true;
      }
    } else {
      item.breakInvalid = true;
      this.addError(index + 1, 'err5', this.getDisDate(item));
      hasError = true;
    }

    // MIDNIGHT BREAK validation
    if (mnBreakTime === '' || mnBreakTime === undefined) {
      // allow blank
    } else if (breakRegex.test(mnBreakTime)) {
      const mnBreakNum = parseInt(mnBreakTime, 10);
      // 深夜勤務時間（0:00〜5:00 + 22:00〜29:00 + 46:00〜48:00）< 深夜休憩時間 → エラー
      if (mnBreakNum > nightWorkTime) {
        item.mnBreakInvalid = true;
        this.addError(index + 1, 'err7', this.getDisDate(item));
        hasError = true;
      }
    } else {
      item.mnBreakInvalid = true;
      this.addError(index + 1, 'err8', this.getDisDate(item));
      hasError = true;
    }

    // -----------------------------
    // WHF + INVALID COMBINATIONS
    // -----------------------------
    const noTimeSpecified =
      startHour === '' ||
      startMinute === '' ||
      endHour === '' ||
      endMinute === '';

    if (item.whf) {
      if (noteVal === 20 || noteVal === 50 || noTimeSpecified) {
        item.whfInvalid = true;
        this.addError(
          index + 1,
          'errWHF',
          this.getDisDate(item)
        );
        hasError = true;
      } else {
        item.whfInvalid = false;
      }
    }

    // NOTE (20) specific rule
    if (noteVal === 20 || noteVal === 50) {
      if (finalStart > 0) {
        item.startInvalid = true;
        this.addError(index + 1, 'err9', this.getDisDate(item));
        hasError = true;
      }
      if (finalEnd > 0) {
        item.endInvalid = true;
        this.addError(index + 1, 'err9', this.getDisDate(item));
        hasError = true;
      }
      if (parseInt(breakTime, 10) > 0) {
        item.breakInvalid = true;
        this.addError(index + 1, 'err9', this.getDisDate(item));
        hasError = true;
      }
      if (parseInt(mnBreakTime, 10) > 0) {
        item.mnBreakInvalid = true;
        this.addError(index + 1, 'err9', this.getDisDate(item));
        hasError = true;
      }
    }

    // Expenses validation
    if (expensesDropDwn > 0) {
      if (expensesVal <= 0) {
        item.costInvalid = true;
        this.addError(index + 1, 'err10', this.getDisDate(item));
        hasError = true;
      }
    } else {
      if (expensesVal > 0) {
        item.costInvalid = true;
        this.addError(index + 1, 'err11', this.getDisDate(item));
        hasError = true;
      }
    }

    return hasError;
  }

  private getDisDate(item: any): string {
    const { day, weekdayKey } = this.getDayWeekKey(item.dayDate);
    const weekday = this.translate.instant(weekdayKey);
    return `${day} ${weekday}`;
  }

  private getAbsoluteMinutes(
    dayDate: string | Date,
    hour: number | string,
    minute: number | string
  ): number {

    if (hour === '' || minute === '' || hour == null || minute == null) {
      return -1;
    }

    const baseDate = new Date(dayDate);
    baseDate.setHours(0, 0, 0, 0);

    const h = +hour;
    const m = +minute;

    // each day = 1440 minutes
    const dayOffset = Math.floor(h / 24);
    const hourInDay = h % 24;

    return (
      baseDate.getTime() / 60000 +   // convert ms → minutes
      dayOffset * 1440 +
      hourInDay * 60 +
      m
    );
  } 
  toggleAllApprovals(event: Event) {
  const input = event.target as HTMLInputElement;
  const isChecked = input.checked;

  this.selectAll = isChecked; // update header state

  // Update all rows
  this.timeSheetData.forEach((item: any) => {
    if(item.status < 20)
    item.markedForSubmit = isChecked;
  });
  this.markDirty();

    console.log('All Approve checkboxes set to:', isChecked);
  }
  onRowApproveChange() {
    this.selectAll = this.timeSheetData.every((item: any) => item.markedForSubmit);
    this.markDirty();
  }
  editReject(index: number) {
    // console.log("here");
    this.editingRow = index;
    this.archive = true;
    this.expandedRows[index] = true;
    this.expandedRowsButton[index] = true;
    this.timeSheetData?.forEach((it: any, i: number) => it.isEditing = i === index);
    // 編集開始時はコメント入力欄を空欄にする（前回コメントは備考欄に表示済み）
    if (this.timeSheetData?.[index]) {
      if (!this.rowBackups[index]) {
        this.rowBackups[index] = JSON.parse(JSON.stringify(this.timeSheetData[index]));
      }
      this.timeSheetData[index].etcRemarks = '';
    }
  }

  cancelReject(index: number) {
    // console.log("cancel reject");
    this.editingRow = null;
    this.archive = false;
    this.selectAll = false;
    this.expandedRows[index] = false;
    this.expandedRowsButton[index] = false;
    this.timeSheetData?.forEach((it: any) => it.isEditing = false);
    // rowBackupsから元の状態に復元（サーバー再取得不要）
    if (this.rowBackups[index]) {
      const nextVersion = (this.timeSheetData[index]?._cancelVersion ?? 0) + 1;
      this.timeSheetData = [
        ...this.timeSheetData.slice(0, index),
        { ...this.rowBackups[index], _cancelVersion: nextVersion },
        ...this.timeSheetData.slice(index + 1)
      ];
      delete this.rowBackups[index];
    }
    this.cdr.detectChanges();
    this.hasUnsavedChanges = false;
  }

  saveReject(index: number) {
    // console.log("save reject");
    let hasError = false;
    const rowItem = [this.timeSheetData[index]];
    hasError = this.validateRow(index);
    
    if (hasError) {
      const errMsg = this.translate.instant('VALIDATION_FAILED');
      alert(errMsg);
      return;
    } 
    // return;
    this.editingRow = null;
    
    const details = rowItem.map((item: any) => ({
      timesheetLineItemId: item.timesheetLineItemId ?? 0,
      dayDate: item.dayDate ?? '',
      // startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg),
      // endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg)).toISOString() ?? '',
      startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg, item.dayDate),  //2026-07-21 add
      endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg, item.dayDate)).toISOString() ?? '', //2026-07-21 add     
      midnightBreakMinutes:  parseInt(item.midnightBreakMinutes, 10) ?? 0,
      breakMinutes:  parseInt(item.breakMinutes, 10) ?? 0,
      noteId: item.noteId ?? 0,
      expenseId: item.expenseId ?? 0,      
      status: 20,
      workingType: 10,
      cost: parseInt(item.cost, 10) ?? 0,
      whf: item.whf ?? false,
      etcRemarks: item.etcRemarks ?? '',
      originalUpdateDate: item.originalUpdateDate
    }));

    const payload = {
      timesheetId: this.timesheetId,
      details
    };
       
    // console.log(payload);
    // return;
    this.ts.saveTimeSheet(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // console.log(res.message)
            // const tableElement = $('#attendanceTable') as any;
            // if ($.fn.dataTable.isDataTable(tableElement)) {
            //     tableElement.DataTable().clear().destroy();
            //   }
            // this.getTimesheetData();
            // this.refreshPage();
            // console.log(this.router.url);
            // this.router.navigate([this.router.url]);
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            this.hasUnsavedChanges = false;
            this.archive = false;
            this.selectAll = false;
            this.expandedRows[index] = false;
            this.expandedRowsButton[index] = false;
            this.timeSheetData?.forEach((it: any) => it.isEditing = false);
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "error";
            this.archive = false;
            this.selectAll = false;
            this.expandedRows[index] = false;
            this.expandedRowsButton[index] = false;
            this.timeSheetData?.forEach((it: any) => it.isEditing = false);
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err.message);
          if (err.status == 401) {
            this.auth.logout();
			      return;
          } else if (err.status == 409) {
            // 競合エラー: 他のユーザーによる更新
            this.dashboard_msg = err.error?.message || "このタイムシートは他のユーザーによって更新されています。画面を再読み込みしてください。";
            this.msgType = "warning";
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
          this.archive = false;
          this.selectAll = false;
          this.expandedRows[index] = false;
          this.expandedRowsButton[index] = false;
          this.timeSheetData?.forEach((it: any) => it.isEditing = false);
        }
    })
  }

  reset() {
    this.dashboard_msg = null;
    this.dashboard_err_msg = [];
  }
  refreshPage() {
    this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }
  
  // TrackBy function for *ngFor optimization
  trackByTimesheetLineItemId(index: number, item: any): any {
    return `${item.timesheetLineItemId || index}_${item._cancelVersion ?? 0}`;
  }
  
  /*----------- Timesheet format logic ------------*/
  getDayWeekKey(dateString: string): { day: string, weekdayKey: string, shortweekday: string } {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const weekdayIndex = date.getDay();

    const weekdayKeys = [
      'WEEKDAYS.SUNDAY',
      'WEEKDAYS.MONDAY',
      'WEEKDAYS.TUESDAY',
      'WEEKDAYS.WEDNESDAY',
      'WEEKDAYS.THURSDAY',
      'WEEKDAYS.FRIDAY',
      'WEEKDAYS.SATURDAY'
    ];

    const weekdayKeysShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    return { day, weekdayKey: weekdayKeys[weekdayIndex], shortweekday: weekdayKeysShort[weekdayIndex] };
  }

  getStatus(status: number): { statusKey: string } {
    let statusIndex = 0;
    if (status == 40) {
      statusIndex = 4;
    } else if (status == 30) {
      statusIndex = 3;
    } else if (status == 20) {
      statusIndex = 1;
    } else {
      statusIndex = 0;
    }
    const statusKeys = [
      "SHORTSTATUS.NOTSUBMIT",
      "SHORTSTATUS.SUBMIT",
      "SHORTSTATUS.FIX",
      "SHORTSTATUS.REJECT",
      "SHORTSTATUS.APPROVE"
    ];
    return {statusKey: statusKeys[statusIndex]}
  }

  getStartTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

 
  toTimeString(dateString: string): string {
    // console.log(dateString);
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  fncCng(event: any) {
    const target = event.target as HTMLSelectElement;
    const nextTimesheetId = target.value;
    if (this.hasUnsavedChanges) {
      const shouldDiscard = this.confirmDiscardUnsavedChanges();
      if (!shouldDiscard) {
        this.selectedTimesheetId = this.timesheetId;
        return;
      }
      this.hasUnsavedChanges = false;
    }
    this.timesheetId = nextTimesheetId;
    this.timesheetIdOrg = Base64UrlService.encode(this.en.encryptionAES(this.timesheetId.toString()));
    this.getTimesheetData();
  }

    /* former version of toIsoString, kept for reference
    private toIsoString(time: any, originalIso: string): string {
    // console.log(time);
    if (typeof time === 'object' && time !== null) {      
      const date = new Date(time);
      const hours = date.getHours();
      const minutes = date.getMinutes();            
      time = `${String(hours)}:${String(minutes)}`;
    }
    // console.log(originalIso);
    if (time.split(":")[0] == '' && time.split(":")[1] == '') {
      originalIso = "1972-01-12T00:00:00"
    }
    const [hours, minutes] = time.split(':').map(Number);
    // const date = new Date(originalIso || new Date());
    // date.setHours(hours, minutes, 0);
    const date = new Date(originalIso || new Date());    
    // Create a new Date object with today's date and given time
    const yyyy = String(date.getFullYear());
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');  
    const hh = String(hours).padStart(2, '0');
    const min = String(minutes).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`;
  }
*/
  // new version of toIsoString with fallbackDate support 2026-07-21
private toIsoString(time: any, originalIso: string, fallbackDate?: string): string {
  if (typeof time === 'object' && time !== null) {
    const date = new Date(time);
    time = `${date.getHours()}:${date.getMinutes()}`;
  }

  const isBlank = time.split(":")[0] == '' && time.split(":")[1] == '';
  if (isBlank) {
    originalIso = "1972-01-12T00:00:00";
  }

  const [hours, minutes] = time.split(':').map(Number);

  // ★ フォールバックは「時刻が入力されている」かつ「元の originalIso が1972プレースホルダー」の場合のみ
  const isPlaceholder = originalIso?.startsWith('1972-01-12');
  const baseIso = (!isBlank && isPlaceholder && fallbackDate)
    ? fallbackDate
    : (originalIso || new Date().toISOString());

  const date = new Date(baseIso);
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(hours).padStart(2, '0');
  const min = String(minutes).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`;
}

  getEndTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getNote(note: number): { noteKey: string } {
    let statusIndex = 0;
    if (note == 10) {
      statusIndex = 0;
    } else if (note == 20) {
      statusIndex = 1;
    } else if (note == 40) {
      statusIndex = 2;
    } else if (note == 50) {
      statusIndex = 3;
    } else {
      statusIndex = 4;
    }
    const noteKeys = [
      "",
      "NOTEDD.PaidLeave",
      "NOTEDD.Tardiness",
      "NOTEDD.Absence",
      "NOTEDD.SeeComment"
    ];
    return {noteKey: noteKeys[statusIndex]}
  }
  
  getExpenses(expenses: number): { expensesKey: string } {
    let statusIndex = 0;
    if (expenses == 0) {
      statusIndex = 0;
    } else if (expenses == 1) {
      statusIndex = 1;
    } else if (expenses == 2) {
      statusIndex = 2;
    }
    const expensesKeys = [
      "",
      "ExpenseDD.AdvancePayment",
      "ExpenseDD.Transportation"
    ];
    return {expensesKey: expensesKeys[statusIndex]}
  }

  getClass(status: number): string {
    if(status == 10 || status == 0){
      return 'tr_non_submit';
    } else if(status == 20){
      return 'tr_submit';
    } else if(status == 30){
      return 'tr_reject';
    } else if(status == 40){
      return 'tr_approve';
    } else {
      return 'tr_non_submit';
    }
  }

  isBreakMinutesInvalid(item: any): boolean {
    return (
      item.breakMinutes === '' ||
      item.breakMinutes === null ||
      isNaN(item.breakMinutes) ||
      String(item.breakMinutes).trim() === ''
    );
  }

  toggleBelowRows(index: number): void {
    console.log(index);
    const opening = !this.expandedRows[index];
    // 他の開いている行を全て閉じる
    if (opening) {
      this.expandedRows.forEach((isOpen, i) => {
        if (isOpen && i !== index) {
          this.expandedRows[i] = false;
          this.expandedRowsButton[i] = false;
          delete this.rowBackups[i];
          delete this.savedScrollPositions[i];
        }
      });
    }
    this.expandedRows[index] = opening;
    this.expandedRowsButton[index] = opening;
    if (opening) {
      this.rowBackups[index] = JSON.parse(JSON.stringify(this.timeSheetData[index]));
      this.savedScrollPositions[index] = window.scrollY;
      setTimeout(() => {
        const el = document.getElementById(`timeSheet_row_${index}`);
        if (el) {
          const headerEl = document.querySelector('header') as HTMLElement;
          const headerH = headerEl ? headerEl.offsetHeight : 70;
          const top = el.getBoundingClientRect().top + window.scrollY - headerH;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 350);
    } else {
      delete this.rowBackups[index];
      const savedY = this.savedScrollPositions[index];
      if (savedY !== undefined) {
        window.scrollTo({ top: savedY, behavior: 'smooth' });
        delete this.savedScrollPositions[index];
      }
    }
  }

  cancelRowExpanded(index: number): void {
    this.hasUnsavedChanges = false;
    this.rowBackups = {};
    this.ts.invalidateTimesheetDataCache(this.timesheetId);
    this.getTimesheetData();
  }

  saveRowExpanded(index: number) {
    const hasError = this.validateRow(index);
    if (hasError) {
      const errMsg = this.translate.instant('VALIDATION_FAILED');
      alert(errMsg);
      return;
    }
    const rowItem = [this.timeSheetData[index]];
    const details = rowItem.map((item: any) => ({
      timesheetLineItemId: item.timesheetLineItemId ?? 0,
      dayDate: item.dayDate ?? '',
      // startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg),
      // endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg)).toISOString() ?? '',
      startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg, item.dayDate),  //2026-07-21 add
      endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg, item.dayDate)).toISOString() ?? '', //2026-07-21 add     
      midnightBreakMinutes: parseInt(item.midnightBreakMinutes, 10) ?? 0,
      breakMinutes: parseInt(item.breakMinutes, 10) ?? 0,
      noteId: item.noteId ?? 0,
      expenseId: item.expenseId ?? 0,
      status: item.markedForSubmit ? 20 : item.status,
      workingType: item.markedForSubmit ? 10 : (item.workingType ?? 0),
      cost: parseInt(item.cost, 10) ?? 0,
      whf: item.whf ?? false,
      etcRemarks: item.etcRemarks ?? '',
      originalUpdateDate: item.originalUpdateDate
    }));
    const payload = { timesheetId: this.timesheetId, details };
    this.ts.saveTimeSheet(payload)
      .subscribe({
        next: (res: any) => {
          this.dashboard_msg = res.message;
          this.msgType = res.status ? 'success' : 'error';
          if (res.status) {
            this.hasUnsavedChanges = false;
            this.expandedRows[index] = false;
            this.expandedRowsButton[index] = false;
            delete this.rowBackups[index];
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err.message);
          if (err.status == 401) { this.auth.logout(); return; }
        }
      });
  }

  onRejectClick(item: any): void {
    if (item.status === 30 || item.status === 20) {      
      // console.log(this.lang + " - - " + );item.timesheetLineItemId
      this.ts.getEtcThread(item.timesheetLineItemId, this.lang )
      .subscribe({
        next: (res: any) => {
            this.thread_msg = res;
            // console.log(this.thread_msg);
          },
          error: (err: any) => {
            console.log(err)
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })

    }
  }

  threadClose() {
    this.thread_msg = null;
  }

  formatDateTime(dateString: string): string {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' }); // "Oct"
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${year}-${month}-${day} : ${hours}:${minutes}`;
  }

  dwnPdf(id: any) {
    this.ts.getPdf(id )
      .subscribe({
        next: (res: any) => {
            const blob = new Blob([res.body ?? res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
          },
          error: (err: any) => {
            console.log(err)
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }

  saveTraining() {    
      const now = new Date();
      const updateDate = now.toISOString();
      
      const payLoad =
      {
        "timesheetId": this.timesheetId,
        "trainingComments": this.trainingComments,
        "trainingCmtUpdateDate": updateDate
      }
      // const modalElement = document.getElementById('training_history_popup');
      // const modalInstance = bootstrap.Modal.getInstance(modalElement) 
      //   || new bootstrap.Modal(modalElement);
      
      this.ts.updateTrainingHistory(payLoad)
        .subscribe({
          next: (res: any) => {
            if (res.status) {
              this.hasUnsavedChanges = false;
              // modalInstance.hide();
              // document.getElementById("btntraining_history_popup")?.click();
              this.triggerClick();
              // $("#btntraining_history_popup").click();
              this.ts.invalidateTimesheetDataCache(this.timesheetId);
              this.getTimesheetData();
              // setTimeout(() => {
              //   document.body.classList.remove('modal-open');
              //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
              // }, 300);
            } else {
              alert(res.message);
            }
          },
          error: (err: any) => {
            console.log(err.message)
            if (err.status == 401) {
              this.auth.logout()
			        return
            }
          }
      })
    }
  
  onCancel() {
    // キャンセルボタンは変更破棄が目的のため、アラートなしで直接リロード
    this.hasUnsavedChanges = false;
    this.getTimesheetData();
  }

  onTimeChange(ev: any, item: any, which: 'start' | 'end') {
    if (which === 'start') {
      item.startHour = ev.hour;
      item.startMinute = ev.minute;
      item.startTime = ev.formatted;
    } else {
      item.endHour = ev.hour;
      item.endMinute = ev.minute;
      item.endTime = ev.formatted;
    }
    this.markDirty();
  }

  canDeactivate(): boolean {
    if (this.auth.isTimingOut || this.isSaving || !this.hasUnsavedChanges) {
      return true;
    }
    return this.confirmDiscardUnsavedChanges();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.isSaving || !this.hasUnsavedChanges) {
      return;
    }
    event.preventDefault();
    event.returnValue = '';
  }

  private confirmDiscardUnsavedChanges(): boolean {
    const confirmMsg = this.translate.instant('UNSAVED_CHANGES_CONFIRM');
    return confirm(
      confirmMsg !== 'UNSAVED_CHANGES_CONFIRM'
        ? confirmMsg
        : 'You have unsaved timesheet changes. Leave this page and discard changes?'
    );
  }

  clearRow(index: number) {
    // バックアップがなければ保存（cancelRowExpandedで復元できるように）
    if (!this.rowBackups[index]) {
      this.rowBackups[index] = JSON.parse(JSON.stringify(this.timeSheetData[index]));
    }

    const item = this.timeSheetData[index];
    
    // Reset time selections
    item.startHour = '';
    item.startMinute = '';
    item.endHour = '';
    item.endMinute = '';
    
    // Reset breaks and expenses
    item.midnightBreakMinutes = '';
    item.breakMinutes = '';
    item.expenseId = '0';
    item.cost = '';
    
    // Reset status-related flags
    item.whf = false;
    item.noteId = 10;  // 10 = 通常勤務（DB の有効な最小値、空ラベル）。'0' は LineItemTypeID に存在しないため FK 違反となる
    item.etcRemarks = '';
    item.markedForSubmit = false;

    // Clear any existing validation error highlights for this row
    item.startInvalid = false;
    item.endInvalid = false;
    item.breakInvalid = false;
    item.mnBreakInvalid = false;
    item.costInvalid = false;

    this.markDirty();    
  }


  onBreakMinutesChange(item: any, val: string): void {
    const cleaned = String(val ?? '').replace(/[^0-9]/g, '');
    item.breakFormatError = cleaned !== String(val ?? '');
    item.breakMinutes = cleaned === '0' ? '' : cleaned;
    this.markDirty();
  }

  onMnBreakMinutesChange(item: any, val: string): void {
    const cleaned = String(val ?? '').replace(/[^0-9]/g, '');
    item.mnBreakFormatError = cleaned !== String(val ?? '');
    item.midnightBreakMinutes = cleaned === '0' ? '' : cleaned;
    this.markDirty();
  }
  markDirty(): void {
    this.hasUnsavedChanges = true;
    this.dashboard_msg = null;
  }
}
